/*
 * Copyright (c) 2019 Euro Games Technology - All rights reserved.
 *
 * File: MostPlayedNums.tsx
 *
 * Written by Stefan Atanasov <stefan.atanasov@egt-bg.com> on 12.09.23 1:49 pm.
 * Last modified: 12.09.23 1:49 pm.
 *
 * More information at: egt-bg.com
 */
import React from 'react';
import { addBuildHash } from '../api/helpers';
import { useLobbyHost } from '../contexts/SettingsContext';

const MostPlayedNums = ({ index }: { index: string }) => {
    const host = useLobbyHost();

    return (
        <div className="egtd_lobby_banner_most_played_num">
            <img src={addBuildHash(`${host}/assets/portal/most_played_numbers/${index[0]}.png`)} alt="" />
            {Boolean(index[1]) && (
                <img src={addBuildHash(`${host}/assets/portal/most_played_numbers/${index[1]}.png`)} alt="" />
            )}
        </div>
    );
};

export default MostPlayedNums;
